module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '/*global define*/\n\ndefine("collections/Tool", [\n    \'underscore\',\n    \'backbone\',\n    \'models/Tool\'\n], function (_, Backbone, ToolModel) {\n    \'use strict\';\n\n    var ToolCollection = Backbone.Collection.extend({\n        model: ToolModel\n    });\n\n    return ToolCollection;\n});\n';

}
return __p
}